import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/(site)/footer-locale-switcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BetaModal"] */ "/app/app/nextjs/app/components/beta-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/components/tos-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/components/upgraded-user-onboarding/gate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/lib/registry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTagManager"] */ "/app/app/nextjs/app/util/gtm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/context/manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteChromeCopyProvider"] */ "/app/app/nextjs/context/site-chrome-copy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/styles/global.ts");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
